module.exports = __webpack_public_path__ + "img/schedule_time_arrow.48842cad.svg";